import React, { useEffect } from "react"
import { View, StyleSheet, ScrollView, Dimensions, Image, BackHandler } from "react-native"
import { Button } from "@Components/CustomButton/Button"
import { ContainerGlogal } from "@Components/ContainerGlogal"
import reinitialisation_cpts from "@assets/icons/reinitialisation_cpts.png"
import reinitialisation_soignant from "@assets/icons/reinitialisation_soignant.png"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors } from "@Constants/baseStyles"
import AnimatedConfirmationCodeInput from "@Components/ConfirmationInput/AnimatedConfirmationInput"
import { useRecoilState } from "recoil"
import { passwordCodeAtom } from "@Recoil/Atom/passwordCodeAtom"
import SimpleGoBackBtn from "@Components/SimpleGoBackBtn/SimpleGoBackBtn"
import Constants from "expo-constants"

const { platform } = Constants.expoConfig.extra
const isCpts = platform === "cpts"

const { height } = Dimensions.get("screen")

export const ForgotPasswordCodePage = ({ navigation }) => {
    const reinitialisationImg = !isCpts ? reinitialisation_soignant : reinitialisation_cpts

    const [code, setCode] = useRecoilState(passwordCodeAtom)
    const backToLogin = () => {
        navigation.navigate("Login")
    }

    useEffect(() => {
        const backAction = () => {
            return true
        }
        const backHandler = BackHandler.addEventListener("hardwareBackPress", backAction)
        return () => backHandler.remove()
    }, [])

    return (
        <ContainerGlogal>
            <SimpleGoBackBtn />

            <ScrollView keyboardShouldPersistTaps={"handled"} contentContainerStyle={{ paddingBottom: 50 }}>
                <Image
                    style={{ alignSelf: "center", marginTop: "12%", height: 104 }}
                    resizeMode={"contain"}
                    source={reinitialisationImg}
                    defaultSource={reinitialisationImg}
                />
                <View style={[styles.container, { marginTop: 0 }]}>
                    <BreeSerifText textAlign={"center"} fontSize={22}>
                        Vérifier votre boîte mail !
                    </BreeSerifText>
                    <OpenSansText fontSize={16} textAlign={"center"} style={{ marginTop: 20 }}>
                        Nous vous avons envoyé un email contenant un code à usage unique pour réinitialiser votre mot de
                        passe.
                    </OpenSansText>
                    <AnimatedConfirmationCodeInput value={code} setValue={setCode} />

                    <Button
                        disabled={code.length < 6}
                        text="Continuer"
                        width="80%"
                        backgroundColor={baseColors.green.primary}
                        onPress={() => {
                            navigation.navigate("PasswordCreateForm")
                        }}
                        labelColor={"white"}
                    />
                    <View style={{ marginTop: height / 5 }}>
                        <OpenSansText
                            textAlign={"center"}
                            color={baseColors.green.primary}
                            fontSize={16}
                            fontWeight={"bold"}
                        >
                            Vous n'avez pas reçu d'email ?
                        </OpenSansText>
                        <OpenSansText
                            style={{ textDecorationLine: "underline" }}
                            textAlign={"center"}
                            color={baseColors.green.primary}
                            fontSize={16}
                            fontWeight={"bold"}
                        >
                            Vérifiez vos spams ou contactez-nous !
                        </OpenSansText>
                    </View>
                </View>
            </ScrollView>
        </ContainerGlogal>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        paddingTop: 20,
        paddingHorizontal: 20,
        backgroundColor: "white",
        alignContent: "center"
    },
    text: {
        color: baseColors.black,
        textAlign: "justify",
        fontFamily: "BreeSerif",
        fontSize: 16
    }
})
